// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Agenda — estils generals del mòdul (contenidor, pestanyes, etc.)
   Nomenclatura pròpia amb prefix "Agenda-" per no interferir amb
   les classes genèriques de dashboard.css.
   ============================================================ */

.Agenda-titol-pagina {
  margin: 0 0 12px 0;
  font-size: 20px;
  color: #333;
}

/* Contenidor del calendari dins la pestanya "Calendari" */
.Agenda-calendari-container {
  padding: 4px 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/agenda.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;AAClB","sourcesContent":["/* ============================================================\r\n   Agenda — estils generals del mòdul (contenidor, pestanyes, etc.)\r\n   Nomenclatura pròpia amb prefix \"Agenda-\" per no interferir amb\r\n   les classes genèriques de dashboard.css.\r\n   ============================================================ */\r\n\r\n.Agenda-titol-pagina {\r\n  margin: 0 0 12px 0;\r\n  font-size: 20px;\r\n  color: #333;\r\n}\r\n\r\n/* Contenidor del calendari dins la pestanya \"Calendari\" */\r\n.Agenda-calendari-container {\r\n  padding: 4px 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
